<template>
  <form id="form-add-document" class="position-relative" @submit.prevent="submit">
    <loader :loading="loadingForm" block />
    <div class="vuedl-layout__closeBtn" @click="close(!isShowMode && !!formFields.length)">
      ×
    </div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        {{ formTitle }}
      </v-card-title>

      <v-card-text class="py-1">
        <div v-if="customerForm && customerForm.id" class="mb-4">
          <a
            :href="`/?customer_id=${customerId}&doctor_id=${doctorId}#/print/inspection?document_id=${customerForm.id}`"
            target="_blank"
            >Распечатать</a
          >
        </div>
        <div v-if="form && form.vks_link" class="mb-4">
          <div class="d-flex">
            <a :href="form.vks_link" target="_blank">Ссылка на консультацию</a>
            <div class="ml-3 d-flex cursor-pointer position-relative" href="#" @click.prevent="copy(form.vks_link)">
              <v-icon>mdi-content-copy</v-icon>
              <div class="text-body-2 ml-2 text--disabled">{{ copyMessage }}</div>
            </div>
          </div>
          <v-btn class="mt-2" color="primary" small @click="open(form)">Открыть видеоконференцию</v-btn>
        </div>
        <v-autocomplete
          label="Тип документа"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          v-model="form.category"
          :loading="loadingTypes"
          :items="eventsTypes"
          :error-messages="typeErrors"
          :readonly="isShowMode"
          :disabled="isShowMode"
          :disable-lookup="isShowMode"
          return-object
          @change="categorySelect"
        >
        </v-autocomplete>
      </v-card-text>
      <template v-if="formFields.length">
        <v-divider class="mt-4 mb-0"></v-divider>
        <v-card-text class="py-1" v-if="(isShowMode && loadingShowModeForm) || !isShowMode">
          <dynamic-form
            :show-mode="isShowMode"
            :readonly="readonly"
            :schema="formFields"
            :validation="$v.form"
            :value="form"
            @input="updateDynamicForm"
            @source-search="onSourceSearch"
            @file-remove="onFileRemove"
          />
        </v-card-text>

        <v-card-text v-if="filesToPreview.length" class="py-1">
          <div>Превью документов</div>

          <div class="row mt-2">
            <div class="col-4" v-for="file in filesToPreview" :key="`file-preview-${file.id}`">
              <div class="position-relative">
                <AuthImage title="Нажмите для просмотра" :path="file.path" />
                <div>{{ file.name }}</div>
              </div>
            </div>
          </div>
        </v-card-text>
      </template>

      <v-divider class="mt-4"></v-divider>
      <div v-if="commonErrors" class="common-errors px-4" v-html="commonErrors"></div>

      <v-card-actions>
        <v-btn id="form-add-document-close" type="button" color="primary" text @click="close(!isShowMode && !!formFields.length)">
          {{ isShowMode ? "Закрыть" : "Отменить" }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="signed" id="form-add-document-show-sign" type="button" color="primary" text disabled>
          Документ подписан
        </v-btn>
        <v-btn
          v-if="customerForm && !customerForm.doctor_sign"
          id="form-add-document-show-sign"
          type="button"
          color="primary"
          text
          @click="initSign"
        >
          {{ showSertList ? "Скрыть" : "Подписать" }}
        </v-btn>
        <v-btn v-if="!readonly" id="form-add-document-submit" type="submit" color="primary" text>
          {{ isShowMode ? "Обновить" : "Сохранить" }}
        </v-btn>
      </v-card-actions>
      <div v-if="customerForm" style="p-2" v-show="showSertList && signServiceInited">
        <v-divider class="mt-4"></v-divider>
        <div>
          <div id="DataToSignDoctorSurName" :data-last-name="$store.state.auth.profile.surname"></div>
          <div
            id="DataToSignTxtBox"
            name="DataToSignTxtBox"
            style="height: 20px; width: 100%; resize: none; border: 0px; display: none;"
            v-html="customerForm.data_to_sign"
          ></div>
          <textarea
            id="SignatureTxtBox"
            readonly=""
            style="font-size:9pt;height:600px;width:100%;resize:none;border:0;display:none"
            ref="doctor_sign"
          ></textarea>
          <div v-if="sertError" class="sert-list text-danger">{{ sertError }}</div>
          <div class="sert-list">
            <div class="h3 mb-2">Выберите сертификат для подписания</div>
            <div id="boxdiv" style="display:none">
              <span id="errorarea">
                У вас отсутствуют личные сертификаты.
              </span>
            </div>
            <select size="8" name="CertListBox" id="CertListBox" style="width:100%;resize:none;border:0;"></select>

            <v-btn depressed color="primary" id="form-add-document-sign" type="button" block @click="sign" class="mt-3">
              Подписать
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper.js";
import Loader from "@/components/Loader.vue";
import DynamicForm from "@/modules/documents/add-document/DynamicForm.vue";
import { uniqueId } from "lodash/util";
import { formModal } from "@/mixins/modal/form-modal.js";
import { API_ERROR_MESSAGE } from "@/config.js";
import { DOCUMENT_AVAILABLE_FIELDS } from "@/modules/documents/add-document/document-available-fields.js";
import imageExtList from "@/services/image-extensions.js";
import { buildDocumentUrl } from "@/services/utils.js";
import AuthImage from "@/components/AuthImage.vue";
import { DynamicFieldsManager } from "./dynamic-fields.manager.js";
import asFormData from "json-form-data";
import { mapMutations } from "vuex";
export default {
  name: "AddDocument",

  components: { AuthImage, DynamicForm, Loader },

  mixins: [formModal],

  props: {
    date: {
      type: String,
      default: "",
    },
    formCategory: {
      type: Number,
      default: 0,
    },
    customerForm: {
      //type: Object,
      default: null,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    // ИД передается если нужно открыть документ для редактирования в разделе "Очередь осмотров"
    employeeId: {
      type: Number,
      default: null,
    },
    doctorId: {
      type: Number,
      default: null,
    },
    documentId: {
      type: Number,
      default: null,
    },
    appointmentId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      signed: false,
      sertError: "",
      signServiceInited: false,
      showSertList: false,

      formTitle: "Добавить документ",
      loadingForm: false,
      loadingShowModeForm: false,

      loadingTypes: false,
      eventsTypes: [],
      formFields: [],
      formSchema: [],
      formDynamicValidation: {
        category: { required },
      },

      copyMessage: "",

      form: {
        author: "",
        category: "",
        files_to_remove: [],
        name: "",
        real_date: "",
        vks_link: "",
      },

      filesToPreview: [],
      commonErrors: "",
    };
  },

  validations() {
    return {
      form: this.formDynamicValidation,
    };
  },

  computed: {
    customerId() {
      if (this.employeeId) {
        return this.employeeId;
      }

      return this.$store.state.customer.id;
    },

    isShowMode() {
      return this.customerForm !== null;
    },

    typeErrors() {
      return messageHelper(this.$v.form.category);
    },
  },

  async created() {
    if (this.isShowMode) {
      await this.readForm(this.$props.customerForm);
    } else {
      await this.loadData();
    }
    if (this.formCategory) {
      this.form.category = this.formCategory;
      this.categorySelect(this.form.category.id);
    }
  },
  methods: {
    ...mapMutations("appointment", ["SET_CURRENT_APPOINTMENT"]),
    async copy(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.copyMessage = "Ссылка скопирована";
      } catch (e) {
        console.log(`e =>`, e);
        this.copyMessage = `Скопировать ссылку не удалось`;
      }
      setTimeout(() => {
        this.copyMessage = ``;
      }, 3000);
    },
    open(item) {
      this.SET_CURRENT_APPOINTMENT({ videoLink: item.vks_link, docId: this.documentId, id: this.appointmentId });
      this.close();
    },
    initSign() {
      this.showSertList = !this.showSertList;
      this.$nextTick(() => {
        document.querySelector("#form-add-document-sign").scrollIntoView();
      });
      if (!this.signServiceInited) {
        document.getElementById("SignatureTxtBox").innerHTML = "";
        var canPromise = !!window.Promise;
        if (window.isEdge()) {
          window.ShowEdgeNotSupported();
        } else {
          if (canPromise) {
            window.cadesplugin.then(
              function() {
                window.Common_CheckForPlugIn();
              },
              function(error) {
                this.sertError = error;
              },
            );
          } else {
            window.addEventListener(
              "message",
              function(event) {
                if (event.data == "cadesplugin_loaded") {
                  window.CheckForPlugIn_NPAPI();
                } else if (event.data == "cadesplugin_load_error") {
                  this.sertError = "Плагин не загружен";
                }
              },
              false,
            );
            window.postMessage("cadesplugin_echo_request", "*");
          }
          this.signServiceInited = true;
        }
      }
    },
    sign() {
      const config = { childList: true };
      this.sertError = "";
      // Колбэк-функция при срабатывании мутации
      const callback = async (_, observer) => {
        // тут шлем запрос
        try {
          const res = await this.$http.post(`v1/customers/${this.customerId}/documents/${this.customerForm.id}/sign`, {
            signed_data: this.customerForm.data_to_sign,
            doctor_sign: this.$refs.doctor_sign.innerHTML,
            certificate: window.sertificateInfo || {},
          });
          if (res.data.success) {
            this.signed = true;
            this.showSertList = false;
            // потом удаляем обзервер
            observer.disconnect();
            const form = {
              ...this.form,
              author: this.$store.state.auth.id,
            };
            await this.update(form);
            window.location.reload();
          } else {
            this.sertError = res.data.message;
          }
        } catch (e) {
          this.sertError = e.response.message;
        }
      };

      // Создаём экземпляр наблюдателя с указанной функцией колбэка
      const observer = new MutationObserver(callback);

      // Начинаем наблюдение за настроенными изменениями целевого элемента
      observer.observe(this.$refs.doctor_sign, config);

      window.Common_SignCadesBES("CertListBox");
    },
    /**
     * Сброс формы
     */
    resetForm() {
      this.$v.$reset();
    },

    async loadData() {
      this.loading(true);

      try {
        const response = await this.$http.get(`v1/documents/types`, { params: { lang: "ru" } });
        this.eventsTypes = response.data.success ? response.data.data : [];
      } catch (e) {
        this.$dialog.notify.error(e.response.message || API_ERROR_MESSAGE);
      }

      this.loading(false);
    },

    /**
     * Загружает для выбранной категории(Типа документа) список полей и сопутствующие данные
     */
    async categorySelect(category) {
      if (category && category.id) {
        this.loading(true);

        try {
          const response = await this.$http.get(`v1/documents/types/${category.id}/fields`, { params: { lang: "ru" } });

          if (response.data.success) {
            const formFields = [];
            for (const item of response.data.data) {
              let sourceItems = [];

              if (item.type === DOCUMENT_AVAILABLE_FIELDS.source && item.behavior?.searchable === false) {
                try {
                  const { data } = await this.$http.get(`v1/documents/types/${category.id}/fields/${item.id}`, {
                    params: { lang: "ru" },
                  });
                  sourceItems = Array.isArray(data.data) ? this.prepareSourceFieldItems(data.data) : [];
                } catch (e) {
                  console.error("Ошибка получения значений справочника");
                }
              }

              formFields.push({ uuid: uniqueId(), ...item, items: sourceItems });
            }

            this.formFields = formFields;
            this.form = { ...this.form, ...DynamicFieldsManager.buildForm(formFields) };

            // Если дата была передана в форму как props используем ее
            if (this.form.real_date === null && this.$props.date) {
              this.form.real_date = this.$props.date;
            }

            if (this.form.category === 132) {
              this.form.real_date = new Date();
            }

            this.formDynamicValidation = DynamicFieldsManager.buildFormValidation(formFields);
          }
        } catch (e) {
          console.log(e);
          this.$dialog.notify.error(e?.response?.message || API_ERROR_MESSAGE);
        }

        this.loading(false);
      }
    },

    /**
     * Хендлер для обновление полей динамической формы
     *
     * @param formData
     */
    updateDynamicForm(formData) {
      this.form = formData;
    },

    async submit() {
      const form = {
        ...this.form,
        author: this.$store.state.auth.id,
      };
      console.log("form", form);

      this.$v.form.$touch();

      if (this.$v.form.$pending || this.$v.form.$error) return;

      this.loadingForm = true;

      // Подготавливаем данные формы для отправки
      // Ищем присутствие файла с типом "params", меняем формат подходящий для API
      for (const field of this.formFields) {
        if (field.type === DOCUMENT_AVAILABLE_FIELDS.params && form[field.name] !== undefined) {
          form[field.name] = (form[field.name] ?? []).map(item => ({
            param: item.param.id,
            measure: item.measure.id || item.measure.measure, //TODO: удалить item.measure.measure после изменения названия поля
            value: item.value,
          }));
        }
        if (field.type === DOCUMENT_AVAILABLE_FIELDS.paramnorms && form[field.name] !== undefined) {
          form[field.name] = (form[field.name] ?? []).map(item => ({
            param: item.param.id,
            measure: item.measure.id || item.measure.measure, //TODO: удалить item.measure.measure после изменения названия поля
            min_value: item.min_value,
            max_value: item.max_value,
          }));
        }

        // Вырезаем из полей типа FILE и DICOM данные которые не являются файлами
        if ([DOCUMENT_AVAILABLE_FIELDS.file, DOCUMENT_AVAILABLE_FIELDS.dicom].includes(field.type)) {
          if (Array.isArray(form[field.name])) {
            form[field.name] = form[field.name].filter(file => file instanceof File);
          } else {
            form[field.name] = form[field.name] instanceof File ? form[field.name] : null;
          }
        }
      }

      // Вырезаем из attach_files данные которые не являются файлами
      form.attach_files = (form.attach_files ?? []).filter(file => file instanceof File);

      if (this.isShowMode) {
        await this.update(form);
      } else {
        await this.create(form);
      }

      this.loadingForm = false;
    },

    async create(form) {
      this.commonErrors = "";
      try {
        const localForm = Object.assign({}, form);
        if (localForm.field_271) {
          localForm["field_271[]"] = localForm.field_271[0];
          delete localForm.field_271;
        }
        if (localForm.field_291) {
          localForm["field_291[]"] = localForm.field_291[0];
          delete localForm.field_291;
        }

        localForm.category = localForm.category.id || localForm.category;

        const response = await this.$http.post(`v1/customers/${this.$store.state.customer.id}/documents`, asFormData(localForm), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.success) {
          this.$store.commit("documents/ADD_ITEM", response.data.data);

          const calendarDate = this.$date(response.data.data.date, "DD.MM.YYYY").format("YYYY-MM-DD");
          this.$store.commit("ikp/ADD_AGENDA", {
            title: response.data.data.name,
            date: calendarDate,
            time: "",
            doc_id: response.data.data.id,
          });
          this.$store.commit("ikp/ADD_CALENDAR", {
            title: response.data.data.name,
            start: calendarDate,
            end: "",
            all_day: false,
            doc_id: response.data.data.id,
          });

          this.$dialog.notify.success(response.data.message);
          console.log(`this.close =>`, this.close);
          this.close();
        } else {
          if (response.error && response.error.response && response.error.response.data) {
            this.commonErrors = `
                <p class="font-bold">${response.error.response.data.message || ""}</p>
                <p class='text-sm'>${response.error.response.data.specification_error || ""}</p>
            `;
          }
        }
      } catch (e) {
        if (e.response && e.response.data) {
          this.commonErrors = `
                <p class="font-bold">${e.response.data.message || ""}</p>
                <p class='text-sm'>${e.response.data.specification_error || ""}</p>
            `;
        }
        this.$dialog.notify.error(e.response.message || API_ERROR_MESSAGE);
      }
    },

    async update(form) {
      this.commonErrors = "";
      const localForm = Object.assign({}, form);
      if (localForm.field_271) {
        localForm["field_271[]"] = localForm.field_271[0];
        delete localForm.field_271;
      }
      if (localForm.field_291) {
        localForm["field_291[]"] = localForm.field_291[0];
        delete localForm.field_291;
      }

      localForm.category = localForm.category.id || localForm.category;

      console.log(`localForm =>`, localForm);
      try {
        const response = await this.$http.post(
          `v1/customers/${this.customerId}/documents/${this.customerForm.id}`,
          asFormData(localForm),
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response.data.success) {
          this.$dialog.notify.success(response.data.message);
          //   this.loadingForm = false;

          //   this.$emit("close");
          //   this.$emit("submit", true);
          this.close();
        } else {
          if (response.error && response.error.response && response.error.response.data) {
            this.commonErrors = `
                <p class="font-bold">${response.error.response.data.message || ""}</p>
                <p class='text-sm'>${response.error.response.data.specification_error || ""}</p>
            `;
          }
        }
      } catch (e) {
        if (e.response && e.response.data) {
          this.commonErrors = `
                <p class="font-bold">${e.response.data.message || ""}</p>
                <p class='text-sm'>${e.response.data.specification_error || ""}</p>
            `;
        }
        this.$dialog.notify.error(e.response.message || API_ERROR_MESSAGE);
      }
    },

    /**
     * Читает ответ от сервера и заполняет поля формы
     *
     * @param {CustomerDocument} form
     * @return {Promise<void>}
     */
    async readForm(form) {
      await this.categorySelect(form.type);
      this.loading(true);

      const dynamicForm = {};
      this.formTitle = form.name;

      this.eventsTypes = [form.type];
      this.form.category = form.type.id;
      this.form.vks_link = form.vks_link || "";

      dynamicForm.name = form.name;
      dynamicForm.real_date = form.date;

      // Заполняем поля формы значениями
      if (form.fields.length > 0) {
        form.fields.forEach(field => {
          dynamicForm[`field_${field.id}`] = field.type === "select" ? JSON.parse(field.value) : field.value;
        });
      }

      // Заполняем форму мед. параметрами если они есть
      if (form.med_params.length > 0) {
        for (const field of this.formFields) {
          if (field.type === DOCUMENT_AVAILABLE_FIELDS.params) {
            dynamicForm[field.name] = form.med_params.map(p => {
              const measure = {
                id: p.measure.id,
                name: p.measure.name,
                min: p.norm.min,
                max: p.norm.max,
              };

              return {
                edit: false,
                uuid: p.id,
                param: {
                  id: p.param_id,
                  name: p.name,
                },
                value: p.value,
                measure,
                measures: [measure],
              };
            });
          }
        }
      }
      if (form.med_norms.length > 0) {
        dynamicForm["field_305"] = form.med_norms.map(p => {
          const measure = {
            id: p.measure.id,
            name: p.measure.name,
            min: p.min_value,
            max: p.max_value,
          };

          return {
            edit: false,
            uuid: p.id,
            param: {
              id: p.param_id,
              name: p.name,
            },
            min_value: p.min_value,
            max_value: p.max_value,
            measure,
            measures: [measure],
          };
        });
      }

      // Проверяем есть ли прикрепленные файлы
      if (form.attachments.length > 0) {
        dynamicForm["attach_files"] = form.attachments;
        this.filesToPreview = form.attachments
          .filter(file => imageExtList.includes(file.extension))
          .map(file => {
            return { ...file, path: buildDocumentUrl(this.customerId, file.id) };
          });
      }

      this.updateDynamicForm({ ...this.form, ...dynamicForm });

      // Получения значений для справочников
      for (const item of this.formFields) {
        if (item.type === DOCUMENT_AVAILABLE_FIELDS.source && item?.behavior?.searchable && dynamicForm[item.name]) {
          try {
            const { data } = await this.$http.get(`v1/documents/types/${form.type.id}/fields/${item.id}`, {
              params: { lang: "ru", id: dynamicForm[item.name].map(Number) },
            });

            item.addedItems = data.data;
          } catch (e) {
            console.error("Ошибка получения значения справочника");
          }
        }
      }

      this.loadingShowModeForm = true;
      this.loadingForm = false;
    },

    /**
     * Подготавливает поля справочника для UI
     */
    prepareSourceFieldItems(items) {
      return items.map(item => {
        if (item.code) {
          item.title = `${item.code} ${item.title}`;
        }

        return item;
      });
    },

    /**
     * Запрашивает данные справочника и добавляет их в переданное поле, данные обновляются так как объект передается по ссылке
     */
    async onSourceSearch({ value, field }) {
      if (Number(field.behavior.searchable_min_cnt) > 0 && value.length < Number(field.behavior.searchable_min_cnt)) {
        return;
      }

      try {
        // const category = this.form.category?.id || this.form.category;
        const { data } = await this.$http.get(`v1/documents/types/${this.form.category}/fields/${field.id}`, {
          params: {
            lang: "ru",
            search: value,
            limit: field.behavior.searchable_limit > 0 ? field.behavior.searchable_limit : null,
          },
        });
        field.items = Array.isArray(data.data) ? this.prepareSourceFieldItems(data.data) : [];
      } catch (e) {
        console.error("Ошибка получения значений справочника", e);
        field.items = [];
      }
    },

    onFileRemove({ field, file }) {
      console.log("fieldName", field);
      console.log("file", file);

      if (!(file instanceof File) && file.id) {
        // Удаляем данные из формы для изменения UI
        if (Array.isArray(this.form[field])) {
          this.form[field] = this.form[field].filter(fileItem => fileItem.id !== file.id);
          console.log("this.form[field]", this.form[field]);
        } else {
          this.form[field] = null;
        }

        this.form.files_to_remove = [...new Set([...this.form.files_to_remove, file.id])];
        this.$dialog.message.info(`Файл ${file.name || file.title} добавлен на удаление`);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.attachment-remove-file {
  position: absolute;
  padding-top: 0;
  margin-top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
<style lang="scss">
.sert-list {
  padding: 10px 20px;
}
#CertListBox {
  display: block;
  outline: none;
  overflow: hidden;
  line-height: 22px;
  font-size: 16px;
  option {
    height: 32px;
    line-height: 32px !important;
    display: flex;
    align-items: center;
    padding: 0 5px;
    &:hover {
      background: #e0e0e0 !important;
      cursor: pointer;
    }
    &:checked,
    &:active,
    &:focus {
      background: #ccc !important;
    }
  }
}
.common-errors {
  margin-top: 16px;
  p {
    margin-bottom: 0;
  }
  p:empty {
    display: none;
  }
  p + p {
    margin-top: 4px;
  }
  .font-bold {
    font-weight: 700;
  }
}
</style>
